<template>
  <v-tooltip left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="pc-loader-button"
        fab
        color="primary"
        elevation="8"
        v-bind="attrs"
        v-on="on"
        @click="handleClick"
      >
        <v-icon color="white">mdi-cloud-upload</v-icon>
      </v-btn>
    </template>
    <span>Point Cloud Loader</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'PointCloudLoaderButton',

  methods: {
    handleClick() {
      this.$emit('toggle')
    }
  }
}
</script>

<style scoped lang="scss">
.pc-loader-button {
  position: absolute;
  bottom: 20px;
  right: 20px;
  z-index: 1100;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
}

/* Responsive adjustments */
@media (max-width: 1264px) {
  .pc-loader-button {
    bottom: 16px;
    right: 16px;
  }
}

@media (max-width: 960px) {
  .pc-loader-button {
    bottom: 12px;
    right: 12px;
  }
}
</style>
